/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styles from '../../../../styles/components/pageComponents/coach/ProgramTable.module.css';
import star from '../../../../assets/profile/Vector (5).png';

// Generic interfaces for modularity
interface Column<T> {
	header: string;
	key: keyof T | 'actions' | 'progress';
	render?: (item: T) => React.ReactNode;
	optional?: boolean;
}

interface ProgramTableProps<T> {
	title?: string;
	data: T[];
	columns: Column<T>[];
	itemsPerPage?: number;
}

const ProgramTable = <T extends { id: string | number }>({
	title,
	data,
	columns,
	itemsPerPage = 5,
}: ProgramTableProps<T>) => {
	const [currentPage, setCurrentPage] = useState(1);

	// Pagination Logic
	const totalPages = Math.ceil(data.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const currentData = data.slice(startIndex, startIndex + itemsPerPage);

	return (
		<div className={styles.container}>
			{title && (
				<div className={styles.headerSection}>
					<span className={styles.iconPlaceholder}>
						<img
							src={star}
							alt="icon"
							className={styles.iconImage}
						/>
					</span>
					<h2 className={styles.title}>{title.toUpperCase()}</h2>
				</div>
			)}

			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							{columns.map((col, index) => (
								<th
									key={index}
									className={
										col.optional ? styles.optionalCol : ''
									}
								>
									{col.header}
								</th>
							))}
						</tr>
					</thead>
					<tbody className={styles.tableBody}>
						{currentData.map(item => (
							<tr key={item.id}>
								{columns.map((col, index) => (
									<td
										key={index}
										className={
											col.optional
												? styles.optionalCol
												: ''
										}
									>
										{col.render
											? col.render(item)
											: (item[
													col.key as keyof T
												] as React.ReactNode)}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles.footer}>
				{/* <div className={styles.pagination}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`${styles.pageBtn} ${currentPage === i + 1 ? styles.activePage : ''}`}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div> */}
				{totalPages > 1 && (
					<div className={styles.pagination}>
						{Array.from({ length: totalPages }, (_, i) => (
							<button
								key={i + 1}
								className={`${styles.pageBtn} ${currentPage === i + 1 ? styles.activePage : ''}`}
								onClick={() => setCurrentPage(i + 1)}
							>
								{i + 1}
							</button>
						))}
					</div>
				)}
				<div className={styles.showingText}>
					Showing {currentData.length} of {data.length}
				</div>
			</div>
		</div>
	);
};

export default ProgramTable;
